import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormCode } from '../models/form/form-code.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmFormCodeService extends RequestService<FormCode> {
  static PATH = '/om/form/code';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmFormCodeService.PATH, globalService.debugUrl);
  }
}
